import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

const About = () => {
  const { t } = useLanguage();
  const { prefix, highlight, suffix } = t.about.titleParts;

  return (
    <section className="mag-about" id="about">
      <div className="mag-about-inner">
        <div className="reveal">
          <h2>
            {prefix}
            <span>{highlight}</span>
            {suffix}
          </h2>
          <div className="mag-about-accent" />
        </div>
        <div className="mag-about-text reveal">
          <p>{t.about.p1}</p>
          <p>{t.about.p2}</p>
        </div>
      </div>
    </section>
  );
};

export default About;
